import React from "react";
import Typography from "components_v2/Typography/Typography";

const NotAssigned = () => {
    return (
        <Typography customVariant="bodySmallRegular">{'Not assigned'}</Typography>
    )
}
export default NotAssigned;